export default __webpack_public_path__ + "static/media/mecha_927_1.c34b319b.jpg";